var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NebulaIcon',{staticClass:"subject-icon",attrs:{"symbol-id":_vm.subjectIcon,"size":"s"}})
}
var staticRenderFns = []

export { render, staticRenderFns }